import summaryCallouts from './summaryCallouts';
import summaryCharts from './summaryCharts';
import topFiveProblems from './topFiveProblems';

export default [summaryCallouts, summaryCharts, topFiveProblems];
